
import React from "react";
import sanitizeHtml from "sanitize-html";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    Typography,

    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Divider,

} from "@mui/material";
import { Iconography, Button } from "@hid-galaxy-ui/galaxy-react";


type Props = {
    onClose: () => void;
    open?: boolean;
    engagementDetails: any

};



const ViewDescriptionModal: React.FC<Props> = ({
    onClose,
    open = true,
    engagementDetails


}) => {

    const decodeHtmlEntities = (value: string): string => {
        if (typeof document === "undefined") return value;
        let current = value;
        // Some records may arrive encoded; decode repeatedly until stable.
        for (let i = 0; i < 3; i += 1) {
            const ta = document.createElement("textarea");
            ta.innerHTML = current;
            const decoded = ta.value;
            if (decoded === current) break;
            current = decoded;
        }
        return current;
    };

    const toSanitizedRichHtml = (content?: string): string => {
        if (!content) return "";
        const hasHtmlEntities = /&(lt|gt|amp|quot|nbsp|#\d+|#x[0-9a-f]+);/i.test(content);
        const decoded = hasHtmlEntities ? decodeHtmlEntities(content) : content;
        const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(decoded);

        if (!hasHtmlTags) {
            const safeText = sanitizeHtml(decoded, { allowedTags: [], allowedAttributes: {} });
            return safeText.replace(/\r\n|\r|\n/g, "<br />").trim();
        }

        return sanitizeHtml(decoded, {
            allowedTags: [
                "p",
                "br",
                "ul",
                "ol",
                "li",
                "strong",
                "b",
                "em",
                "i",
                "u",
                "s",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "a",
            ],
            allowedAttributes: {
                a: ["href", "target", "rel"],
            },
            allowedSchemes: ["http", "https", "mailto", "tel"],
            transformTags: {
                a: sanitizeHtml.simpleTransform("a", {
                    target: "_blank",
                    rel: "noopener noreferrer",
                }),
            },
        }).trim();
    };





    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    boxShadow: "0px 12px 24px rgba(0,0,0,0.12)",
                    overflow: "hidden",
                },
            }}>
            <DialogTitle
                sx={{
                    pb: 0,
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                }}
            >
                <Box sx={{ pr: 1 }}>
                    <Typography
                        sx={{
                            width: "436px",
                            height: "30px",
                            fontFamily: "'Roboto'",
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "26px",
                            lineHeight: "30px",
                            letterSpacing: "0.2px",
                            color: "#222222",
                            mt: 1.5,
                        }}
                    >
                        {engagementDetails.activity_name}
                    </Typography>
                </Box>

                <IconButton aria-label="Close" onClick={onClose} sx={{ mt: 0.5 }}>
                    <Iconography icon="xmark" />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: 2 }}>



                <Box sx={{ mb: 2, pt: 1 }}>
                    <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                        <b>Description</b>
                    </Typography>
                    <Box
                        sx={{ color: "text.secondary", lineHeight: 1.7, fontSize: "0.875rem" }}
                        dangerouslySetInnerHTML={{
                            __html: toSanitizedRichHtml(engagementDetails?.description),
                        }}
                    />
                </Box>


                <Box sx={{ mt: 3, mb: 1 }}>
                    <Typography variant="subtitle1" fontWeight={600}>
                        <b>Levels and corresponding Accelerator value</b>
                    </Typography>
                </Box>



                <Paper variant="outlined" sx={{ mb: 3 }}>
                    <Table size="small" aria-label="accelerator table">
                        <TableHead>
                            <TableRow>
                                <TableCell className="pd15">Levels</TableCell>
                                <TableCell className="pd15">Accelerator Value</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>


                            {
                                engagementDetails && engagementDetails.accelerator_value && 
                                engagementDetails.accelerator_value.length ? 
                                engagementDetails.accelerator_value
                                    .map((r_data:any,idx:number) => (
                                        <TableRow key={`${idx}`}>
  <TableCell className="pd15">{r_data.option_key}</TableCell>
                                                            <TableCell className="pd15">{r_data.option_value}</TableCell>
                                            {/* {
                                                Object.entries(r).map(([key, value]) => {
                                                    return (
                                                        <>
                                                            <TableCell className="pd15">{key}</TableCell>
                                                            <TableCell className="pd15">{value}</TableCell>
                                                        </>
                                                    );
                                                })
                                            } */}



                                        </TableRow>
                                    ))
                                :'No data available'
                                }
                        </TableBody>
                    </Table>
                </Paper>


                <Box
                    sx={{
                        bgcolor: (theme) => theme.palette.action.hover,
                        borderRadius: 1.5,
                        p: 2,
                    }}
                >

                    <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                        <b>Comments</b>
                    </Typography>
                    <Box
                        sx={{ color: "text.secondary", lineHeight: 1.7, fontSize: "0.875rem" }}
                        dangerouslySetInnerHTML={{
                            __html: toSanitizedRichHtml(engagementDetails?.comments),
                        }}
                    />
                </Box>




            </DialogContent>


        </Dialog>
    );
};

export default ViewDescriptionModal;